<template>
  <div
    :class="{
      content: true,
      page: page.total > queryParams.Limit,
    }"
    ref="content"
  >
    <div class="main-content">
      <div class="search-box" ref="search">
        <a-form>
          <a-row>
            <a-col :xxl="4" :xs="6" :md="8" v-if="departments.length > 0">
              <s-select
                title="区域"
                :labelCol="7"
                :valueCol="16"
                v-model:value="queryParams.DepartmentId"
                :options="departments"
              />
            </a-col>
            <a-col :xxl="4" :xs="6" :md="8">
              <s-input
                title="服务查询"
                :labelCol="7"
                :valueCol="16"
                v-model:value="queryParams.GoodsKey"
                placeholder="服务名称"
              />
            </a-col>
            <a-col :xxl="4" :xs="6" :md="8">
              <s-input
                title="用户查询"
                :labelCol="7"
                :valueCol="16"
                v-model:value="queryParams.CustomerKey"
                placeholder="用户姓名\手机号\住址"
              />
            </a-col>
            <a-col :xxl="4" :xs="6" :md="8">
              <s-input
                title="工人查询"
                :labelCol="7"
                :valueCol="16"
                v-model:value="queryParams.WorkerKey"
                placeholder="维修师傅姓名\手机号"
              />
            </a-col>
            <a-col :xxl="4" :xs="6" :md="8">
              <s-select
                title="订单状态"
                :labelCol="7"
                :valueCol="16"
                v-model:value="queryParams.Status"
                :options="status"
              />
            </a-col>
            <a-col :xxl="4" :xs="6" :md="8">
              <s-date-time
                title="开始时间"
                :labelCol="7"
                :valueCol="16"
                v-model:value="queryParams.BeginDate"
              />
            </a-col>
            <a-col :xxl="4" :xs="6" :md="8">
              <s-date-time
                title="结束时间"
                :labelCol="7"
                :valueCol="16"
                v-model:value="queryParams.EndDate"
              />
            </a-col>
            <a-col>
              <a-button type="primary" @click="getDataList(1)"> 查询 </a-button>
              <a-button
                type="primary"
                @click="reset(() => resetFun())"
                danger
                style="margin-left: 10px"
              >
                重置
              </a-button>
              <a-button
                type="primary"
                style="margin-left: 10px"
                @click="exportExcel"
              >
                导出订单
              </a-button>
              <a-button
                type="primary"
                style="margin-left: 10px"
                @click="exportMerge"
              >
                导出维修工订单
              </a-button>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <div class="data-list">
        <a-table
          :columns="columns"
          :data-source="list"
          :pagination="false"
          :loading="loading"
          :row-key="(record) => record.id"
          :scroll="{ y: height, x: width }"
        >
          <template #bodyCell="{ column, record, index }">
            <template v-if="column.key === 'index'">
              {{ (page.page - 1) * queryParams.Limit + index + 1 }}
            </template>

            <template v-if="column.key === 'createTime'">
              {{ $filters.formatDate(record.createTime) }}
            </template>

            <template v-if="column.key === 'customerName'">
              <div>{{ record.customerName }}</div>
              <div>{{ record.customerMobile }}</div>
              <div>{{ record.address }}</div>
            </template>

            <template v-if="column.key === 'status'">
              <a-tag :color="statusColor[record.status]">{{
                statusZh[record.status]
              }}</a-tag>
            </template>

            <template v-if="column.key === 'userinfo'">
              <div>{{ record.user.name }}</div>
              <div>{{ record.user.mobile }}</div>
            </template>

            <template v-if="column.key === 'visitPics'">
              <div v-if="record.visitPicsArray.length > 0">
                <template v-for="(v, k) in record.visitPicsArray" :key="k">
                  <a-tooltip>
                    <template #title>查看图片</template>
                    <a @click.stop="$refs.viewImage.open(v)">
                      <picture-outlined />
                    </a>
                  </a-tooltip>
                  <a-divider type="vertical" />
                </template>

                <a-tooltip>
                  <template #title>编辑</template>
                  <a @click.stop="onSetVisitPics(record)">
                    <EditOutlined />
                  </a>
                </a-tooltip>
              </div>
              <div v-else>
                暂无
                <a-divider type="vertical" />
                <a-tooltip>
                  <template #title>编辑</template>
                  <a @click.stop="onSetVisitPics(record)">
                    <EditOutlined />
                  </a>
                </a-tooltip>
              </div>
            </template>

            <template v-if="column.key === 'maintancePics'">
              <div v-if="record.maintancePicsArray.length > 0">
                <template v-for="(v, k) in record.maintancePicsArray" :key="k">
                  <a-tooltip>
                    <template #title>查看图片</template>
                    <a @click.stop="$refs.viewImage.open(v)">
                      <picture-outlined />
                    </a>
                  </a-tooltip>
                  <a-divider type="vertical" />
                </template>

                <a-tooltip>
                  <template #title>编辑</template>
                  <a @click.stop="onSetMaintancePics(record)">
                    <EditOutlined />
                  </a>
                </a-tooltip>
              </div>
              <div v-else>
                暂无
                <a-divider type="vertical" />
                <a-tooltip>
                  <template #title>编辑</template>
                  <a @click.stop="onSetMaintancePics(record)">
                    <EditOutlined />
                  </a>
                </a-tooltip>
              </div>
            </template>

            <template v-if="column.key === 'warrantyPics'">
              <div v-if="record.warrantyPicsArray.length > 0">
                <template v-for="(v, k) in record.warrantyPicsArray" :key="k">
                  <a-tooltip>
                    <template #title>查看图片</template>
                    <a @click.stop="$refs.viewImage.open(v)">
                      <picture-outlined />
                    </a>
                  </a-tooltip>
                  <a-divider type="vertical" />
                </template>

                <a-tooltip>
                  <template #title>编辑</template>
                  <a @click.stop="onSetWarrantyPics(record)">
                    <EditOutlined />
                  </a>
                </a-tooltip>
              </div>
              <div v-else>
                暂无
                <a-divider type="vertical" />
                <a-tooltip>
                  <template #title>编辑</template>
                  <a @click.stop="onSetWarrantyPics(record)">
                    <EditOutlined />
                  </a>
                </a-tooltip>
              </div>
            </template>

            <template v-if="column.key === 'maintanceVideos'">
              <div v-if="record.maintanceVideosArray.length > 0">
                <template
                  v-for="(v, k) in record.maintanceVideosArray"
                  :key="k"
                >
                  <a-tooltip>
                    <template #title>查看视频</template>
                    <a @click.stop="$refs.viewVideo.open(v)">
                      <video-camera-outlined />
                    </a>
                  </a-tooltip>
                  <a-divider type="vertical" />
                </template>

                <a-tooltip>
                  <template #title>编辑</template>
                  <a @click.stop="onSetMaintanceVideos(record)">
                    <EditOutlined />
                  </a>
                </a-tooltip>
              </div>
              <div v-else>
                暂无
                <a-divider type="vertical" />
                <a-tooltip>
                  <template #title>编辑</template>
                  <a @click.stop="onSetMaintanceVideos(record)">
                    <EditOutlined />
                  </a>
                </a-tooltip>
              </div>
            </template>

            <template v-if="column.key === 'maintanceAudios'">
              <div v-if="record.maintanceAudiosArray.length > 0">
                <template
                  v-for="(v, k) in record.maintanceAudiosArray"
                  :key="k"
                >
                  <a-tooltip>
                    <template #title>查看音频</template>
                    <a @click.stop="$refs.viewAudio.open(v)">
                      <audio-outlined />
                    </a>
                  </a-tooltip>
                  <a-divider type="vertical" />
                </template>

                <a-tooltip>
                  <template #title>编辑</template>
                  <a @click.stop="onSetMaintanceAudios(record)">
                    <EditOutlined />
                  </a>
                </a-tooltip>
              </div>
              <div v-else>
                暂无
                <a-divider type="vertical" />
                <a-tooltip>
                  <template #title>编辑</template>
                  <a @click.stop="onSetMaintanceAudios(record)">
                    <EditOutlined />
                  </a>
                </a-tooltip>
              </div>
            </template>

            <template v-if="column.key === 'goods'">
              <div class="goods">
                <div class="pic">
                  <img :src="record.goods.pic" alt="" />
                </div>
                <div class="info">
                  <div class="title">{{ record.goods.title }}</div>
                  <div class="price">
                    ¥{{ record.goods.promotionPrice }} / {{ record.goods.unit }}
                  </div>
                </div>
              </div>
            </template>

            <template v-if="column.key === 'worker'">
              <div v-if="record.worker">
                <div>
                  {{ record.worker.name }}
                  <a-tooltip>
                    <template #title>重新指派维修师傅</template>
                    <a @click.stop="showUser(record)"
                      ><user-switch-outlined
                    /></a>
                  </a-tooltip>
                </div>
                <div>{{ record.worker.mobile }}</div>
              </div>
              <div v-else>
                <a-button size="small" @click="showUser(record)">
                  指派工人
                </a-button>
              </div>
            </template>

            <template v-if="column.key === 'action'">
              <a-tooltip v-if="record.status < 4">
                <template #title>退单</template>
                <a @click.stop="onChargeback(record)">
                  <stop-outlined />
                </a>
              </a-tooltip>
              <stop-outlined v-else style="color: #ccc" />
              <a-divider type="vertical" v-if="record.qrcode" />
              <a-tooltip v-if="record.qrcode">
                <template #title>付款二维码</template>
                <a @click.stop="$refs.viewImage.open(api + record.qrcode)">
                  <qrcode-outlined />
                </a>
              </a-tooltip>
            </template>
          </template>
        </a-table>
      </div>
    </div>

    <div class="pagination">
      <a-pagination
        :total="page.total"
        v-model:page-size="queryParams.Limit"
        :hide-on-single-page="true"
        :show-size-changer="true"
        :page-size-options="['20', '40', '100', '200', '500']"
        @change="changePage"
        @showSizeChange="onShowSizeChange"
      >
        <template #itemRender="{ page, type }">
          <a v-if="type === 'prev'" class="ant-pagination-item-link">上一页</a>
          <a v-else-if="type === 'next'" class="ant-pagination-item-link">
            下一页
          </a>
          <span v-else>{{ page }}</span>
        </template>
      </a-pagination>
      <span>数据总数：{{ page.total }}</span>
    </div>

    <AssignUser ref="assignUser" @ok="onSetWorker" />
    <ViewImage ref="viewImage" />
    <EditPics ref="editPics" @ok="onEditOrder" />
    <EditVideos ref="editVideos" @ok="onEditOrder" />
    <EditAudios ref="editAudios" @ok="onEditOrder" />
    <ViewVideo ref="viewVideo" />
    <ViewAudio ref="viewAudio" />
  </div>
</template>

<script>
import { defineComponent, ref, createVNode } from 'vue'
import {
  UserSwitchOutlined,
  PictureOutlined,
  EditOutlined,
  VideoCameraOutlined,
  AudioOutlined,
  StopOutlined,
  QrcodeOutlined,
  ExclamationCircleOutlined
} from '@ant-design/icons-vue'
import { OrderClass } from '@/apis/goods'
import page from '@/mixins/page'
import AssignUser from '@/components/forms/order/AssignUser.vue'
import EditPics from '@/components/forms/order/EditPics.vue'
import EditVideos from '@/components/forms/order/EditVideos.vue'
import EditAudios from '@/components/forms/order/EditAudios.vue'
import ViewImage from '@/components/ViewImage.vue'
import ViewVideo from '@/components/ViewVideo.vue'
import ViewAudio from '@/components/ViewAudio.vue'
import dayjs from 'dayjs'
import fileDownload from 'js-file-download'

const api = new OrderClass()
export default defineComponent({
  mixins: [page],
  components: {
    AssignUser,
    EditPics,
    ViewImage,
    UserSwitchOutlined,
    PictureOutlined,
    EditOutlined,
    ViewVideo,
    EditVideos,
    ViewAudio,
    EditAudios,
    VideoCameraOutlined,
    AudioOutlined,
    StopOutlined,
    QrcodeOutlined
  },
  setup () {
    const loading = ref(false)
    const activeKey = ref(-1)
    const height = ref(500)
    const width = ref(500)
    const userId = ref('')
    const visiblePassword = ref(false)

    const columns = [
      {
        title: '订单号',
        dataIndex: 'orderNo',
        key: 'orderNo',
        width: 150
      },
      {
        title: '服务',
        dataIndex: 'goods',
        key: 'goods',
        width: 220
      },
      {
        title: '客户信息',
        dataIndex: 'customerName',
        key: 'customerName',
        width: 200
      },
      {
        title: '地区',
        dataIndex: 'departmentName',
        key: 'departmentName',
        width: 120
      },
      {
        title: '维修师傅',
        dataIndex: 'worker',
        key: 'worker',
        width: 150
      },
      {
        title: '订单金额',
        dataIndex: 'orderAmount',
        key: 'orderAmount',
        width: 120
      },
      {
        title: '订单状态',
        dataIndex: 'status',
        key: 'status',
        width: 120
      },
      {
        title: '用户信息',
        dataIndex: 'userinfo',
        key: 'userinfo',
        width: 200
      },
      {
        title: '上门照',
        dataIndex: 'visitPics',
        key: 'visitPics',
        width: 120
      },
      {
        title: '维修照片',
        dataIndex: 'maintancePics',
        key: 'maintancePics',
        width: 120
      },
      {
        title: '维修录音',
        dataIndex: 'maintanceAudios',
        key: 'maintanceAudios',
        width: 120
      },
      {
        title: '维修视频',
        dataIndex: 'maintanceVideos',
        key: 'maintanceVideos',
        width: 120
      },
      {
        title: '保修卡',
        dataIndex: 'warrantyPics',
        key: 'warrantyPics',
        width: 120
      },

      {
        title: '下单时间',
        dataIndex: 'createTime',
        key: 'createTime',
        width: 200
      },
      {
        title: '操作',
        dataIndex: 'action',
        key: 'action',
        fixed: 'right',
        width: 100
      }
    ]

    const statusZh = [
      '待指派',
      '已指派',
      '进行中',
      '待付款',
      '已付款',
      '已分账',
      '已退单'
    ]
    const statusColor = [
      '#108ee9',
      '#87d068',
      '#2db7f5',
      '#f50',
      '#87e8de',
      '#87e8de',
      '#ccc'
    ]
    const orderId = ref('')
    const order = ref({})

    const departments = ref([])
    return {
      activeKey,
      columns,
      loading,
      height,
      width,
      userId,
      statusZh,
      statusColor,
      orderId,
      order,
      visiblePassword,
      departments
    }
  },
  data () {
    return {
      status: this.$store.state.app.ORDER_STATUS,
      api: this.$store.state.app.api_host
    }
  },
  created () {
    this.getDataList(1)

    this.getDepartments()
  },
  methods: {
    async getDepartments () {
      const list =
        this.$store.state.data.ALL_DEPARTMENTS.length > 0
          ? this.$store.state.data.ALL_DEPARTMENTS
          : await this.$store.dispatch('GetAllDepartment')

      console.log(list)
      const vlist = []
      list.map((e) => {
        vlist.push({
          label: e.name,
          value: e.id
        })
      })

      if (!this.$store.state.user.userInfo.departmentId) {
        this.departments = vlist
      }
    },
    getDataList (page) {
      this.loading = true
      this.page.page = page
      const q = { ...this.queryParams }
      q.Offset = (page - 1) * q.Limit

      if (q.BeginDate) {
        q.BeginDate = q.BeginDate.format('YYYY-MM-DD')
      }
      if (q.EndDate) {
        q.EndDate = q.EndDate.format('YYYY-MM-DD')
      }
      if (this.$store.state.user.userInfo.departmentId) {
        q.DepartmentId = this.$store.state.user.userInfo.departmentId
      }

      api.gets(q).then((resp) => {
        this.list = resp.data
        this.page.total = resp.total
        this.loading = false
        this.getTableHeight()
      })
    },
    exportExcel () {
      const q = { ...this.queryParams }
      q.Offset = (this.page.page - 1) * q.Limit

      if (q.BeginDate) {
        q.BeginDate = q.BeginDate.format('YYYY-MM-DD')
      }
      if (q.EndDate) {
        q.EndDate = q.EndDate.format('YYYY-MM-DD')
      }

      if (this.$store.state.user.userInfo.departmentId) {
        q.DepartmentId = this.$store.state.user.userInfo.departmentId
      }
      api.exportAll(q).then((resp) => {
        fileDownload(resp, '订单' + dayjs().format('YYYYMMDDHHmmss') + '.xlsx')
      })
    },
    exportMerge () {
      const q = { ...this.queryParams }
      q.Offset = (this.page.page - 1) * q.Limit

      if (q.BeginDate) {
        q.BeginDate = q.BeginDate.format('YYYY-MM-DD')
      }
      if (q.EndDate) {
        q.EndDate = q.EndDate.format('YYYY-MM-DD')
      }

      if (this.$store.state.user.userInfo.departmentId) {
        q.DepartmentId = this.$store.state.user.userInfo.departmentId
      }
      api.exportMerge(q).then((resp) => {
        fileDownload(
          resp,
          '维修工订单资金' + dayjs().format('YYYYMMDDHHmmss') + '.xlsx'
        )
      })
    },
    resetFun () {
      this.queryParams = {
        Limit: 20
      }

      this.getDataList(1)
    },

    getTableHeight () {
      const paddingBottom = this.page.total > this.queryParams.Limit ? 50 : 9
      const mainPadding = 30
      const thead = 56
      this.height =
        this.$refs.content.offsetHeight -
        this.$refs.search.offsetHeight -
        thead -
        paddingBottom -
        mainPadding

      this.width = this.$refs.search.offsetWidth - 10
    },
    formOk () {
      this.getDataList(1)
    },

    onSetVisitPics (record) {
      this.order = record
      this.$refs.editPics.open(
        record.visitPics,
        '编辑上门图片',
        'visitPics',
        record.id
      )
    },
    onSetMaintancePics (record) {
      this.order = record
      this.$refs.editPics.open(
        record.maintancePics,
        '编辑维修图片',
        'maintancePics',
        record.id
      )
    },
    onSetMaintanceAudios (record) {
      this.order = record
      this.$refs.editAudios.open(
        record.maintanceAudios,
        '编辑维修录音',
        'maintanceAudios',
        record.id
      )
    },
    onSetMaintanceVideos (record) {
      this.order = record
      this.$refs.editVideos.open(
        record.maintanceVideos,
        '编辑维修视频',
        'maintanceVideos',
        record.id
      )
    },
    onSetWarrantyPics (record) {
      this.order = record
      this.$refs.editPics.open(
        record.warrantyPics,
        '编辑保修卡图片',
        'warrantyPics',
        record.id
      )
    },

    onEditOrder (e) {
      const data = {
        id: this.order.id,
        userId: this.order.userId,
        orderNo: this.order.orderNo,
        status: this.order.status,
        customerName: this.order.customerName,
        customerMobile: this.order.customerMobile,
        address: this.order.address,
        goodsId: this.order.goodsId,
        orderAmount: this.order.orderAmount,
        workerId: this.order.workerId,
        visitPics: this.order.visitPics,
        maintancePics: this.order.maintancePics,
        maintanceVideos: this.order.maintanceVideos,
        maintanceAudios: this.order.maintanceAudios,
        warrantyPics: this.order.warrantyPics
      }
      data[`${e.field}`] = e.data

      api.update(data).then(() => {
        this.$refs.editPics.onClose()
        this.$refs.editVideos.onClose()
        this.$refs.editAudios.onClose()
        this.getDataList(this.page.page)
      })
    },

    showUser (order) {
      this.orderId = order.id

      this.$refs.assignUser.open(order.department)
    },
    onSetWorker (e) {
      api.setWorker(this.orderId, e.id).then(() => {
        this.getDataList(this.page.page)
      })
    },

    onChargeback (record) {
      const _this = this
      _this.$confirm({
        title: '确定退单?',
        icon: createVNode(ExclamationCircleOutlined),
        content: createVNode(
          'div',
          {
            style: 'color:red;'
          },
          `退单单号：${record.orderNo}`
        ),

        onOk () {
          api.status(record.id, 6).then(() => {
            _this.$message.success('退单成功！')
            _this.getDataList(_this.page.page)
          })
        }
      })
    }
  }
})
</script>

<style lang="less" scoped>
.goods {
  display: flex;
  .pic {
    width: 60px;
    height: 60px;
    overflow: hidden;
    img {
      display: block;
      width: 100%;
    }
  }
  .info {
    padding-left: 10px;
    .title {
      font-size: 18px;
      line-height: 36px;
    }
  }
}
</style>
